import { WebXRSessionManager } from '@babylonjs/core/XR/webXRSessionManager';
import { IXrHitResult, XrHitTester } from './xr-hit-tester';

export interface IXrTransientHitResult {
    inputSource: XRInputSource;
    results: IXrHitResult[];
}

export class XrTransientHitTester {
    constructor(public sessionMgr: WebXRSessionManager) {}

    /** holds the hit test source which is filled after initialize() has been called */
    public source: XRTransientInputHitTestSource | undefined;

    public initialize(offsetRay?: XRRay) {
        const session = this.sessionMgr.session;

        return session.requestHitTestSourceForTransientInput!({
            profile: 'generic-touchscreen',
            offsetRay: offsetRay,
        }).then(hitSource => {
            return (this.source = hitSource);
        });
    }

    public getFingers(frame: XRFrame): IXrTransientHitResult[] {
        if (!this.source) return [];

        const fingers = frame.getHitTestResultsForTransientInput(this.source);
        if (!fingers.length) return [];

        const convertedFingers = new Array<IXrTransientHitResult>();
        for (const f of fingers) {
            const r = {
                inputSource: f.inputSource,
                results: [],
            } as IXrTransientHitResult;
            convertedFingers.push(r);

            for (const hit of f.results) {
                const convertedHit = XrHitTester.FromXRHitTestResult(hit, this.sessionMgr.referenceSpace);
                if (convertedHit) r.results.push(convertedHit);
            }
        }

        return convertedFingers;
    }

    public dispose() {
        if (this.source) {
            this.source.cancel();
            this.source = undefined;
        }
    }
}
